import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { BreadcrumbListSchema, WebPageSchema } from '@/components/feature/StructuredData';
import { categories, articles } from '@/mocks/articles';

const categoryImages: Record<string, string> = {
  'chigua-baoliao': 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20news%20abstract%20artistic%20visual%20with%20warm%20dark%20cinematic%20mood%20dramatic%20lighting%20editorial%20photography%20atmosphere%20red%20and%20black%20tones&width=1600&height=900&seq=cat-chigua&orientation=landscape',
  'wanghong-heiliao': 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20abstract%20visual%20with%20dramatic%20shadows%20and%20warm%20amber%20highlights%20cinematic%20editorial%20photography%20moody%20atmosphere%20artistic%20grain%20texture&width=1600&height=900&seq=cat-heiliao&orientation=landscape',
  'remen-shijian': 'https://readdy.ai/api/search-image?query=Trending%20news%20abstract%20visual%20with%20dynamic%20warm%20lighting%20bold%20composition%20cinematic%20editorial%20style%20dramatic%20atmosphere%20with%20deep%20rich%20tones&width=1600&height=900&seq=cat-remen&orientation=landscape',
  'shishi-zhuizong': 'https://readdy.ai/api/search-image?query=Real%20time%20tracking%20abstract%20visual%20with%20motion%20blur%20effect%20warm%20dark%20tones%20editorial%20photography%20dynamic%20composition%20cinematic%20mood&width=1600&height=900&seq=cat-shishi&orientation=landscape',
  'shipin-gengxin': 'https://readdy.ai/api/search-image?query=Video%20content%20abstract%20visual%20with%20warm%20cinematic%20lighting%20film%20reel%20aesthetic%20dark%20atmospheric%20background%20editorial%20photography%20dramatic%20composition&width=1600&height=900&seq=cat-shipin&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  const displayCategory = category || {
    name: slug || '未知分类',
    slug: slug || '',
    count: categoryArticles.length,
    description: '浏览该分类下的所有精彩内容',
  };

  const heroImage = categoryImages[slug || ''] || categoryImages['chigua-baoliao'];

  return (
    <>
      <WebPageSchema
        title={`${displayCategory.name} - 91在线视频`}
        description={displayCategory.description}
        url={`https://www.91zaixianshipin.com/category/${displayCategory.slug}`}
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://www.91zaixianshipin.com/' },
          { name: displayCategory.name, url: `https://www.91zaixianshipin.com/category/${displayCategory.slug}` },
        ]}
      />
      <Navbar />
      <main className="pt-16">
        <nav className="w-full px-4 md:px-6 py-4" aria-label="面包屑导航">
          <div className="max-w-7xl mx-auto">
            <ol className="flex items-center gap-2 text-xs text-foreground-500">
              <li>
                <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </li>
              <li>
                <span className="text-foreground-800 font-medium">{displayCategory.name}</span>
              </li>
            </ol>
          </div>
        </nav>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto text-center">
              <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-label mb-6 whitespace-nowrap">
                {displayCategory.name} · 共 {displayCategory.count} 篇文章
              </span>
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-4">
                {displayCategory.name}
              </h1>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto mb-10">
                {displayCategory.description}
              </p>
              <div className="flex items-center justify-center gap-3">
                <button className="px-6 py-2.5 rounded-full bg-foreground-950 text-background-50 font-label text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                  关注分类
                </button>
                <Link
                  to="/about"
                  className="px-6 py-2.5 rounded-full border border-foreground-200 text-foreground-700 font-label text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  分享爆料
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
          <img
            src={heroImage}
            alt={displayCategory.name}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50"></div>
        </section>

        <section className="bg-background-100 py-16 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  该分类下的 <span className="text-primary-500">最新猛料</span>
                </h2>
                <span className="px-3 py-1.5 rounded-full bg-secondary-500 text-background-50 text-xs font-label whitespace-nowrap">
                  共{categoryArticles.length}篇
                </span>
              </div>

              {categoryArticles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {categoryArticles.map((article) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="group block bg-background-50 rounded-lg overflow-hidden hover:bg-background-50 transition-colors cursor-pointer"
                    >
                      <div className="aspect-[4/3] overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-xs text-primary-500 font-label">{article.category}</span>
                          <span className="text-xs text-foreground-400">{article.date}</span>
                        </div>
                        <h3 className="text-base font-heading font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                          {article.title}
                        </h3>
                        <p className="text-sm text-foreground-600 mt-2 line-clamp-2">{article.excerpt}</p>
                        <div className="flex items-center gap-3 mt-3">
                          <div className="flex items-center gap-1">
                            <i className="ri-eye-line text-xs text-foreground-400"></i>
                            <span className="text-xs text-foreground-500">
                              {article.readCount > 100000
                                ? `${(article.readCount / 10000).toFixed(1)}万`
                                : article.readCount}
                            </span>
                          </div>
                          <div className="flex items-center gap-1">
                            <i className="ri-star-fill text-xs text-accent-500"></i>
                            <span className="text-xs text-foreground-500">{article.rating}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <p className="text-foreground-500 text-lg">该分类暂无文章</p>
                  <Link to="/" className="text-primary-500 mt-4 inline-block text-sm hover:text-primary-600 transition-colors">
                    返回首页
                  </Link>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}